import { getUrlParam } from '../helpers';

const defaultParams = {
  debug: false,
  delivery_platform: 'Terminal',
  locale: 'en',
  company_uuid: 'b99752b3-443c-4c80-b559-945a95c4b805', // Prva firma
  env: 'staging',
};

const company = {
  uuid: getUrlParam('companyUuid') || defaultParams.company_uuid,
  locale: getUrlParam('lang') || defaultParams.locale,
};

const API = {
  tc: 'https://frasier.de-2.nsoft.cloud',
};

export default {
  debug: !!getUrlParam('debug') || defaultParams.debug,
  delivery_platform: getUrlParam('delivery_platform') || defaultParams.delivery_platform,
  company,
  API,
  env: getUrlParam('env') || defaultParams.env,
  dataFormat: {
    default: 'object',
    matches: 'array',
    betGroups: 'array',
  },
  dataShrink: !defaultParams.debug,
};

export { company, API };
